import { Navigate, createBrowserRouter } from 'react-router-dom';
import { AuthLayout, DashboardLayout } from '../layouts';
import { ROLES } from '../utils/constants';
import Login from '../views/Login/Login';
import { checkAccessRights } from '../utils/functions/accessRight';
import ProtectedRoutes from './ProtectedRoutes';
import InvoiceMain from '../views/InvoiceService/InvoiceMain';
import WaitingForPayment from '../views/WaitingForPayment/WaitingForPayment';
import PaymentHistory from '../views/PaymentHistory/PaymentHistory';
import CsatProgress from '../components/CsatProgress';
import Pending from '../views/PayEvidenceStatus/Pending';
import Approved from '../views/PayEvidenceStatus/Approved';
import Rejected from '../views/PayEvidenceStatus/Rejected';
import StatementOnline from '../views/StatementOnline/StateMentOnline';
import LogStatement from '../views/StatementOnline/LogStatement';
import PendingDetail from '../views/PayEvidenceStatus/PendingDetail';
import Invoices from '../views/UsageHistory/Invoices';
import CreditNote from '../views/UsageHistory/CreditNote';
import LoginHistory from '../views/UsageHistory/Login';
import Receipt from '../views/UsageHistory/Receipt';
import Upload from '../views/UsageHistory/Upload';
import MatchingMain from '../views/Matching/MatchingMain';
import ReportUnmatchMain from '../views/ReportUnmatch/ReportUnmatchMain';
import ReportMatch from '../views/ReportMatch/ReportMatch';
import Withholding from '../views/UsageHistory/Withholding';
import CustomerManage from '../components/CustomerManage';
import Report from '../views/UsageHistory/Report';
import NotFound from '../components/NotFound/NotFound';
import Settings from '../views/Setting/Settings';
import UserManagement from '../views/UserManagement/UserManagement';
import OfflinePayment from '../views/Transactions/OfflinePayment';
import BillPayment from '../views/Transactions/BillPayment';
import LoginAdmin from '../views/Login/LoginAdmin';
import PaymentTransactionResult from '../views/PaymentTransactionResult';
import PreviewPDF from '../components/ExportPDF/PreviewPDF';
import Case from '../views/Case/Case';
import { canAccessCaseManagement } from '../utils/functions/caseManagementAccess';
import Dashboard from '../views/Dashboard/Dashboard';
import { canAccessDashboard } from '../utils/functions/dashboardAccess';
import DataExport from '../views/DataExport/DataExport';
import { canAccessDataExport } from '../utils/functions/dataExportAccess';

function CaseManagementRoute() {
  return canAccessCaseManagement() ? <Case /> : <Navigate to="/404" />;
}

function DataExportRoute() {
  return canAccessDataExport() ? <DataExport /> : <Navigate to="/404" />;
}

function DashboardRoute() {
  return canAccessDashboard() ? <Dashboard /> : <Navigate to="/404" />;
}

const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [{ path: '/login', element: <Login /> }],
  },
  {
    element: <AuthLayout />,
    children: [{ path: '/login-admin', element: <LoginAdmin /> }],
  },
  {
    element: (
      <ProtectedRoutes
        allowedRoles={[
          ROLES.USER_ROLE,
          ROLES.ADMIN_ROLE,
          ROLES.SUPER_ADMIN_ROLE,
          ROLES.SALE_ROLE, 
        ]}
      />
    ),
    children: [
      {
        element: <DashboardLayout checkAccessRights={checkAccessRights} />,
        children: [
          { path: '/', element: <InvoiceMain /> },
          { path: '/invoice-main', element: <InvoiceMain /> },
          { path: '/waiting-for-payment', element: <WaitingForPayment /> },
          { path: '/payment-history', element: <PaymentHistory /> },
          { path: '/csat-progress', element: <CsatProgress /> },
        ],
      },
    ],
  },
  {
    element: (
      <ProtectedRoutes
        allowedRoles={[ROLES.ADMIN_ROLE, ROLES.SUPER_ADMIN_ROLE]}
      />
    ),
    children: [
      {
        element: <DashboardLayout checkAccessRights={checkAccessRights} />,
        children: [
          { path: '/pending', element: <Pending /> },
          { path: '/approved', element: <Approved /> },
          { path: '/rejected', element: <Rejected /> },
          { path: '/online-statement', element: <StatementOnline /> },
          { path: '/log-statement', element: <LogStatement /> },
          { path: '/pending-detail', element: <PendingDetail /> },
          { path: '/Usage-history-invoices', element: <Invoices /> },
          { path: '/Usage-history-creditNote', element: <CreditNote /> },
          { path: '/Usage-history-login', element: <LoginHistory /> },
          { path: '/Usage-history-Receipt', element: <Receipt /> },
          { path: '/Usage-history-Upload', element: <Upload /> },
          { path: '/Matching-Main', element: <MatchingMain /> },
          { path: '/ReportUnmatch-Main', element: <ReportUnmatchMain /> },
          { path: '/ReportMatch', element: <ReportMatch /> },
          { path: '/Withholding', element: <Withholding /> },
          { path: '/CustomerManage', element: <CustomerManage /> },
          { path: '/Report', element: <Report /> },
          { path: '/data-export', element: <DataExportRoute /> },
        ],
      },
    ],
  },
  {
    element: (
      <ProtectedRoutes allowedRoles={[ROLES.ADMIN_ROLE, ROLES.SUPER_ADMIN_ROLE]} />
    ),
    children: [
      {
        element: <DashboardLayout checkAccessRights={checkAccessRights} />,
        children: [
          { path: '/bill-payment', element: <BillPayment /> },
          { path: '/offline-payment', element: <OfflinePayment /> },
        ],
      },
    ],
  },
  {
    // ❌ ถอด ROLES.SALE_ROLE ออกจากตรงนี้ เพื่อไม่ให้ SALE เข้าหน้าจัดการผู้ใช้ได้
    element: <ProtectedRoutes allowedRoles={[ROLES.SUPER_ADMIN_ROLE]} />, 
    children: [
      {
        element: <DashboardLayout checkAccessRights={checkAccessRights} />,
        children: [
          { path: '/user-management', element: <UserManagement /> },
          { path: '/settings', element: <Settings /> },
          { path: '/case', element: <CaseManagementRoute /> },
          { path: '/dashboard', element: <DashboardRoute /> },
        ],
      },
    ],
  },
  {
    path: '/preview-pdf',
    element: <PreviewPDF />,
  },
  {
    path: '/payment-transaction-result/:token',
    element: <PaymentTransactionResult />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

export default router;
